import React from 'react';
import { getAuth, signInWithPopup, GoogleAuthProvider, FacebookAuthProvider } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const SocialLogin = ({ isDarkMode }) => {
  const auth = getAuth();
  const navigate = useNavigate();

  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      navigate('/');
    } catch (error) {
      console.error('Google error:', error);
    }
  };

  const signInWithFacebook = async () => {
    const provider = new FacebookAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      navigate('/');
    } catch (error) {
      console.error('Facebook error:', error);
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
      width: '100%',
      maxWidth: '200px'
    }}>
      {/* Google - მხოლოდ იკონა */}
      <button
        onClick={signInWithGoogle}
        style={{
          width: '100%',
          padding: '8px 12px',
          fontSize: '13px',
          fontWeight: '500',
          background: isDarkMode ? '#2a2a3e' : '#ffffff',
          color: isDarkMode ? '#fff' : '#333',
          border: `1px solid ${isDarkMode ? '#444' : '#ddd'}`,
          borderRadius: '6px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px',
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => e.target.style.background = isDarkMode ? '#3a3a4e' : '#f0f0f0'}
        onMouseLeave={(e) => e.target.style.background = isDarkMode ? '#2a2a3e' : '#ffffff'}
      >
        <img 
          src="https://www.google.com/favicon.ico" 
          alt="Google" 
          style={{ width: '16px', height: '16px' }}
        />
        Google
      </button>

      {/* Facebook - მხოლოდ იკონა */}
      <button
        onClick={signInWithFacebook}
        style={{
          width: '100%',
          padding: '8px 12px',
          fontSize: '13px',
          fontWeight: '500',
          background: '#1877F2',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px',
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => e.target.style.background = '#166fe0'}
        onMouseLeave={(e) => e.target.style.background = '#1877F2'}
      >
        <img 
          src="https://www.facebook.com/favicon.ico" 
          alt="Facebook" 
          style={{ width: '16px', height: '16px' }}
        />
        Facebook
      </button>
    </div>
  );
};

export default SocialLogin;